import { Link } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import styled from 'styled-components';

const Container = styled.div`
  padding: 48px;
  text-align: center;

  h1 {
    margin-bottom: 12px;
  }

  p {
    margin-bottom: 24px;
    color: #666;
  }

  a {
    color: #5949d1;
    text-decoration: none;
    font-weight: 600;
  }
`;

const Unauthorized = () => (
  <Layout>
    <Container>
      <h1>Access denied</h1>
      <p>You do not have permission to view this page.</p>
      <Link to="/events">Back to Events</Link>
    </Container>
  </Layout>
);

export default Unauthorized;
